const defaults = {
  element: null,
  subText: '[data-role*="sub-text"]',
  space: 8,
  container: '[data-role*="double-text-container"]',
  char: '[class*="char"]',
  dots: '[data-role*="dots"]',
};

export default class HoverLetterSpacing {
  constructor(props) {
    const options = Object.assign({}, defaults, props);

    this.element = options.element;
    if (!this.element) return;
    this.subText = this.element.closest(options.subText);
    this.space = options.space;
    this.chars = this.element.querySelectorAll(options.char);
    this.container = this.element.closest(options.container) || this.element;
    this.pair = this.chars.length % 2 === 0;
    this.middle = Math.ceil(this.chars.length / 2) - 1;
    this.dots = this.container.querySelector(options.dots);

    this.init();
  }

  toggleClasses(e, direction) {
    if (!this.subText) return;
    const { offsetY } = e;
    const { offsetHeight } = this.container;
    this.subText.classList.toggle('is-bot_in', direction === 'in' && offsetY > offsetHeight / 2);
    this.subText.classList.toggle('is-bot_out', direction === 'out' && offsetY > offsetHeight / 2);
    this.subText.classList.toggle('is-top_in', direction === 'in' && offsetY < offsetHeight / 2);
    this.subText.classList.toggle('is-top_out', direction === 'out' && offsetY < offsetHeight / 2);
  }

  addEvents() {
    this.container.addEventListener('mouseenter', (e) => {
      this.toggleClasses(e, 'in');
      if (this.dots) {
        $(this.dots).css({
          transform: `translateX(${(2 + this.middle) * this.space}px)`,
        });
      }
      let p = 1;
      const start = this.pair ? this.middle : this.middle - 1;
      for (let i = start; i >= 0; i -= 1) {
        const mult = (this.pair && p === 1) ? 0.5 : p;
        $(this.chars[i]).css({
          transform: `translateX(-${this.space * mult}px)`,
        });
        $(this.chars[this.middle + p]).css({
          transform: `translateX(${this.space * mult}px)`,
        });
        p += 1;
      }
    });
    this.container.addEventListener('mouseleave', (e) => {
      this.toggleClasses(e, 'out');
      $(this.chars).css({
        transform: '',
      });
      $(this.dots).css({
        transform: '',
      });
    });
  }

  init() {
    $(this.subText).css({
      left: `-${this.chars.length / 2 * this.space}px`,
      width: `calc(100% + ${this.chars.length * this.space}px)`,
    });

    this.addEvents();
  }
}




// WEBPACK FOOTER //
// ./scripts/utils/hover-letter-spacing.js